import { randomUUID } from 'node:crypto';
import bcrypt from 'bcryptjs';
import { Router } from 'express';
import { z } from 'zod';
import { createToken } from './auth';
import { pool } from './db';
import { generateAvailableUsername } from './usernames';

export const registrationRouter = Router();
const registrationSchema = z.object({
  email: z.email().max(254),
  password: z.string().min(10).max(128),
  displayName: z.string().trim().min(2).max(80),
  username: z.string().trim().toLowerCase().regex(/^[a-z][a-z0-9_-]{3,29}$/).optional(),
});

registrationRouter.post('/auth/register', async (request, response) => {
  const parsed = registrationSchema.safeParse(request.body);
  if (!parsed.success) { response.status(400).json({ error: 'Invalid registration data' }); return; }
  const email = parsed.data.email.trim().toLowerCase();
  const passwordHash = await bcrypt.hash(parsed.data.password, 12);
  const userId = randomUUID();
  const client = await pool.connect();
  let username = '';
  try {
    await client.query('BEGIN');
    username = await generateAvailableUsername(client, parsed.data.displayName);
    await client.query(
      `INSERT INTO users (id,email,password_hash,display_name,username,role)
       VALUES ($1,$2,$3,$4,$5,'user')`,
      [userId, email, passwordHash, parsed.data.displayName, username],
    );
    await client.query('INSERT INTO profiles (user_id,display_name) VALUES ($1,$2)',
      [userId, parsed.data.displayName]);
    await client.query("INSERT INTO audit_events (user_id,event_type) VALUES ($1,'account_registered')", [userId]);
    await client.query('COMMIT');
  } catch (error) {
    await client.query('ROLLBACK');
    if (typeof error === 'object' && error !== null && 'code' in error && error.code === '23505') {
      response.status(409).json({ error: 'Email is already registered' }); return;
    }
    throw error;
  } finally { client.release(); }
  const user = { id: userId, email, username, displayName: parsed.data.displayName,
    role: 'user' as const, accountType: 'candidate' as const };
  response.status(201).json({ token: createToken(user, 0), user });
});
